import { Component } from 'react';
import Page from '@ui/components/ams/Pages/Page';
import AMS from '@ui/components/ams';
import { withServerSideProps } from '@lib/withServerSideProps';
import { homePageQuery } from '@queries/pages/home';
import { mapHomePageData } from '@lib/page-data/home.map';
import { pushPageViewEvent } from '@lib/atm';
import { PAGE_HOME } from '@lib/constants';

class HomePage extends Component {
  componentDidMount() {
    const {
      userSessionData: {
        userData,
      },
      locale,
    } = this.props;

    pushPageViewEvent(
      window,
      userData,
      { locale, sections: [PAGE_HOME] }
    );
  }

  render() {
    const {
      globalPageData,
      pageData,
      userSessionData,
      requestData,
      locale,
    } = this.props;

    const {
      homeData,
      adConfig,
      searchNavBarData,
      globalGreetingSectionConfig,
      headerSection,
      anonLayout,
      loggedLayout,
      pageAds,
    } = pageData;

    return (
      <Page
        analyticsPageName={PAGE_HOME}
        pageName={PAGE_HOME}
        pageTitle={homeData.pageTitle}
        metaDescription={homeData.metaDescription}
        globalPageData={globalPageData}
        requestData={requestData}
        userSessionData={userSessionData}
        pageAds={pageAds}
      >
        <AMS.HomeContent
          searchNavBarData={searchNavBarData}
          globalGreetingSectionConfig={globalGreetingSectionConfig}
          urlLocale={locale}
          anonLayout={anonLayout}
          loggedLayout={loggedLayout}
          headerSectionData={headerSection}
          adConfig={adConfig}
          pageHeader={homeData.displayName}
        />
      </Page>
    );
  }
}

export const getServerSideProps = withServerSideProps({
  pageQuery: homePageQuery,
  pageDataMapper: mapHomePageData,
});

export default HomePage;
